import { REPORT } from 'config/api-routes';
import { GET, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class ReportService {
  async getReportReasons(opts = {}) {
    const response = await GET(REPORT.LIST.REASON.GET(), opts);

    return formatResponse(response);
  }

  async createReport(data, opts = {}) {
    const response = await POST(REPORT.CREATE.POST(), data, opts);

    return formatResponse(response);
  }
}
